import { render, staticRenderFns } from "./CardSlide.vue?vue&type=template&id=15ea883a&"
import script from "./CardSlide.vue?vue&type=script&lang=js&"
export * from "./CardSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports